"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Culture = void 0;
let Culture = exports.Culture = void 0;
(function (_Culture) {
  let TextDirection = /*#__PURE__*/function (TextDirection) {
    TextDirection["LTR"] = "ltr";
    TextDirection["RTL"] = "rtl";
    return TextDirection;
  }({});
  _Culture.TextDirection = TextDirection;
  /**
   * Primary locale code used everywhere in the Prezly app.
   */
  /**
   * Locale ISO code to be used in HTML attributes.
   */
  function isoCode(code) {
    return code.replace('_', '-');
  }
  _Culture.isoCode = isoCode;
})(Culture || (exports.Culture = Culture = {}));